"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function StrategicCounselForModernEnterprise() {
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: ctaRef,
    isVisible: isCtaVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    once: true
  });
  return <section data-section-id="233025" id="rapid-response-hub" className="dark bg-background text-foreground relative min-h-screen flex flex-col lg:flex-row overflow-hidden">
      <style>{`
        @keyframes scrollLine {
          0% { transform: translateY(-100%); }
          100% { transform: translateY(200%); }
        }
        .animate-scroll-line {
          animation: scrollLine 2s cubic-bezier(0.77, 0, 0.175, 1) infinite;
        }
      `}</style>

      {}
      <div className="flex-1 flex flex-col justify-center px-8 py-24 lg:px-16 xl:px-24 z-10 relative">
        <div ref={textRef} className={`max-w-2xl transition-all duration-1000 ease-out ${isTextVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="inline-block bg-primary/20 border border-primary/50 px-3 py-1 rounded-full mb-6 shadow-[0_0_15px_rgba(249,115,22,0.3)]">
            <span className="text-primary font-mono text-sm font-bold tracking-widest uppercase">24/7 Emergency Service</span>
          </div>
          
          <h1 className="font-default text-5xl md:text-6xl lg:text-7xl font-black tracking-tighter text-foreground mb-8 leading-[1.1] uppercase italic">
            Mobile Tyre Fitting in Leeds – We Come to You Fast
          </h1>
          
          <p className="font-default text-lg md:text-xl text-muted-foreground mb-12 leading-relaxed max-w-xl">
            Stranded with a flat? Drive Mobile Tyres Leeds provides emergency tyre repair and fitting across the city. Our local experts guarantee a <span className="text-primary font-mono font-bold">30–60 minute arrival</span> to get you back on the road safely.
          </p>

          <div ref={ctaRef} className={`transition-all duration-1000 delay-300 ease-out ${isCtaVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
            <Button size="lg" className="h-16 px-10 text-lg font-bold tracking-tight rounded-full shadow-lg shadow-primary/20 hover:shadow-primary/40 transition-all" asChild>
              <Link to="#">
                CALL NOW FOR ASSISTANCE
                <ArrowRight className="ml-2 size-6" />
              </Link>
            </Button>
          </div>
        </div>

        {}
        <div className="absolute bottom-8 left-8 lg:left-16 xl:left-24 flex flex-col items-center gap-4 opacity-60 hidden md:flex">
          <span className="text-[10px] uppercase tracking-[0.2em] font-mono text-primary rotate-180" style={{
          writingMode: 'vertical-rl'
        }}>
            Fast Response
          </span>
          <div className="w-[1px] h-16 bg-border relative overflow-hidden">
            <div className="absolute top-0 left-0 w-full h-1/2 bg-primary animate-scroll-line" />
          </div>
        </div>
      </div>

      {}
      <div className="flex-1 relative min-h-[50vh] lg:min-h-screen w-full">
        <div className="absolute inset-0 bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1647150/img/leeds_night_service_van.png)]" />
        {}
        <div className="absolute inset-0 bg-gradient-to-r from-background via-background/90 to-transparent lg:bg-gradient-to-r lg:from-background lg:via-background/40 lg:to-transparent" />
      </div>
    </section>;
}